import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { ProductCard } from '../ui/ProductCard'

export function ProductCategories() {
  const { t } = useTranslation()

  const products = [
    {
      key: 'outsourcing',
      imageSrc: '/images/products/produzione_estera.jpg',
      imageHoverSrc: '/images/products/produzione_estera_bn.jpg',
      to: 'product-outsourcing',
    },
    {
      key: 'machining',
      imageSrc: '/images/products/lavorazioni_meccaniche.jpg',
      imageHoverSrc: '/images/products/lavorazioni_meccaniche_bn.jpg',
      to: 'product-machining',
    },
    {
      key: 'transmission',
      imageSrc: '/images/products/organi_trasmissione.jpg',
      imageHoverSrc: '/images/products/organi_trasmissione_bn.jpg',
      to: 'product-transmission',
    },
    {
      key: 'plastics',
      imageSrc: '/images/products/materie_plastiche.jpg',
      imageHoverSrc: '/images/products/materie_plastiche_bn.jpg',
      to: 'product-plastics',
    },
  ]

  return (
    <Section>
      <Container>
        <SectionTitle
          title={t('home.products.title')}
          subtitle={t('home.products.subtitle')}
          centered
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => (
            <ProductCard
              key={product.key}
              title={t(`home.products.${product.key}.title`)}
              description={t(`home.products.${product.key}.description`)}
              imageSrc={product.imageSrc}
              imageHoverSrc={product.imageHoverSrc}
              to={product.to}
            />
          ))}
        </div>
      </Container>
    </Section>
  )
}
